import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import ErrorMessage from 'components/share/ErrorMessage'
import { WidgetGuard } from 'features/types'
import { ErrorCode } from 'enums'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { FetchErrorResponse } from 'api'

const DemographicCompareInvalidFilterGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  if (
    !widgetData ||
    (widgetData.status === 'failed' &&
      (widgetData?.error as FetchErrorResponse)?.status === ErrorCode.COMPARE_INVALID_FILTER)
  )
    return <ErrorMessage>{t('compareInvalidFilter')}</ErrorMessage>

  return children
}

export default DemographicCompareInvalidFilterGuard
